import listTemplate from './views/pages/list.tpl.html';
import editorTemplate from './views/pages/editor.tpl.html';
import UsersListController from './controllers/pages/list';
import UserEditCtrl from './controllers/pages/edit';

angular
    .module('festzelt-os.modules.users')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.users', {
            abstract: true,
            url: '/users/',
            template: '<ui-view/>',
            data: {
                pageTitle: 'Users',
                showBackBtn: true
            }
        })
        .state('app.users.index', {
            url: '',
            sticky: true,
            templateUrl: listTemplate,
            controller: UsersListController,
            controllerAs: 'vm',
            data: {
                right: 'users::list'
            }
        })
        .state('app.users.edit', {
            url: '{id}/edit',
            sticky: true,
            templateUrl: editorTemplate,
            controller: UserEditCtrl,
            controllerAs: 'vm',
            data: {
                right: 'users::edit'
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/modules/users/routes.js